<template>
    <div>
        <label>
            {{ tra.start_date }} 
            <span v-if="postErrors.start_date" class="h6 text-danger">
                ( {{ postErrors.start_date[0] }} )
            </span> 
        </label>

        <div>
            <DatePicker 
                :model-value="startDate"
                @update:model-value="$emit('update-start-date', $event)"
                :disabledDays="[0, 2, 3, 4, 5, 6]" 
                :disabledDates="disabledVacationDates" 
                :invalid="!startDate"
                :placeholder="tra.start_date" 
                :showIcon="true" 
                iconDisplay="input"
                icon="fal fa-calendar" 
                size="small" 
                dateFormat="dd-mm-yy" 
            />

            <input type="hidden" name="start_date" :value="formatDate(startDate)">
        </div>
    </div>
</template>

<script>
import DatePicker from 'primevue/datepicker';

export default {
    name: 'StartDatePicker',
    components: {
        DatePicker,
    },
    props: {
        startDate: [Date, String],
        disabledVacationDates: Array,
        postErrors: Object,
        tra: Object,
    },
    emits: ['update-start-date'],
    methods: {
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            return `${day}-${month}-${year}`;
        }
    }
};
</script>